import { api } from "api/api";
import { AxiosError } from "axios";
import Usuario from "model/administracao/cadastro/Usuario";
import Veiculo from "model/gestao/frotas/Veiculo";
import VeiculoViagem from "model/gestao/frotas/VeiculoViagem";
import VeiculoViagemFinalizar from "model/gestao/frotas/VeiculoViagemFinalizar";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class VeiculoViagemService implements BaseServiceCadastros<VeiculoViagem> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/veiculoViagem/pesquisar`;
            url += getFilters(filters)
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<VeiculoViagem>((resolve, reject): void => {
            api
                .get(`/veiculoViagem/consultar/${id}`)
                .then(response => {
                    resolve(response.data)
                })
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    finalizar(dados: VeiculoViagemFinalizar) {
        return new Promise<void>((resolve, reject): void => {
            api
            .post(`/veiculoViagem/finalizar`, dados)
            .then(() => resolve())
            .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(formData: FormData) {
        return new Promise<VeiculoViagem>((resolve, reject): void => {
        });
    }

    editar(formData: FormData) {
        return new Promise<VeiculoViagem>((resolve, reject): void => {

        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
        });
    }

    getStatus(status: string): string {
        if (status === "EM_ANDAMENTO") return "Em andamento";
        if (status === "FINALIZADA") return "Finalizada";
        return status;
    }

    getStatusesFilter() {
        return [
            { label: 'Em andamento', value: 'A' },
            { label: 'Finalizada', value: 'F' },
        ]
    }


    getUsuarios() {
        return new Promise<Array<Usuario>>((resolve, reject): void => {
            api
                .get(`/veiculoViagem/usuarios`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    veiculosDisponiveis() {
        return new Promise<Veiculo[]>((resolve, reject): void => {
            api
                .get('/veiculoViagem/veiculosDisponiveis')
                .then((response) => resolve(response.data))
                .catch((error) => reject(error.response));
        });
    }

}

export default VeiculoViagemService;